import { DENTAL } from 'core/constants/products'
import { Pivot } from 'types'

interface AddonsByPlan {
  [key: number]: number[]
}

function getValidatedAddons(store: Pivot.State): AddonsByPlan {
  const validatedAddonsByPlan = {}
  if (store.addonsByPlan) {
    Object.keys(store.addonsByPlan).forEach(planId => {
      const planAddons = store.addonsByPlan[planId] || []
      validatedAddonsByPlan[planId] = planAddons.filter(addonId => {
        const addon = store.plans[addonId]

        if (addon && addon.productId === DENTAL) {
          return !store.hasDentalActive
        }

        return addon
      })
    })
  }
  return validatedAddonsByPlan
}

export default getValidatedAddons
